import React, { useState, useEffect, useRef } from 'react';
import { Table, Button, Card, Typography, Tag, Modal, Form, Select, InputNumber, Input, Row, Col, Divider, message, Steps, Alert, Checkbox, Space, Popconfirm, Tooltip, DatePicker, Switch, Tabs } from 'antd';
import { PlusOutlined, FileTextOutlined, EyeOutlined, CalculatorOutlined, SearchOutlined, EditOutlined, DeleteOutlined, FilePdfOutlined, CalendarOutlined, ShoppingCartOutlined, MessageOutlined, SendOutlined, DollarOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import dayjs from 'dayjs';
import PropostasProdutosLista from './PropostasProdutosLista';

const { Title, Text } = Typography;
const { Option } = Select;

const FORMAS_PAGAMENTO = ['À vista','Pix','Boleto','Cartão de crédito','10 dias','15 dias','30 dias','60 dias','90 dias','120 dias','30/60','30/60/90','10 dias fora mês de emissão da NF'];
const STATUS_PGTO_CORES = { pendente: 'orange', pago: 'green', inadimplente: 'red', parcelado: 'blue' };
const STATUS_PGTO_LABELS = { pendente: 'Pendente', pago: 'Pago', inadimplente: 'Inadimplente', parcelado: 'Parcelado' };
const STATUS_NF_CORES = { nao_emitida: 'default', emitida: 'blue', cancelada: 'red' };
const STATUS_NF_LABELS = { nao_emitida: 'Sem NF', emitida: 'NF Emitida', cancelada: 'NF Cancelada' };

const STATUS_CORES = { rascunho: 'default', proposta_enviada: 'blue', oc_recebida: 'cyan', agendado: 'purple', inspecionado: 'orange', laudo_emitido: 'green', nf_emitida: 'gold' };
const STATUS_LABELS = { rascunho: 'Rascunho', proposta_enviada: 'Enviada', oc_recebida: 'OC Recebida', agendado: 'Agendado', inspecionado: 'Inspecionado', laudo_emitido: 'Laudo Emitido', nf_emitida: 'NF Emitida' };

function Propostas() {
  const [propostas, setPropostas] = useState([]);
  const [servicos, setServicos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [step, setStep] = useState(0);
  const [tipoDeslocamento, setTipoDeslocamento] = useState('perto');
  const [creaForaMG, setCreaForaMG] = useState(false);
  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const [cnpjSelecionado, setCnpjSelecionado] = useState(null);
  const [cnpjs, setCnpjs] = useState([]);
  const [enderecos, setEnderecos] = useState([]);
  const [contatos, setContatos] = useState([]);
  const [itensProposta, setItensProposta] = useState([]);
  const [calculo, setCalculo] = useState(null);
  const [buscandoCnpj, setBuscandoCnpj] = useState(false);
  const [modalFinanceiro, setModalFinanceiro] = useState(false);
  const [propostaSel, setPropostaSel] = useState(null);
  const [formFin] = Form.useForm();
  const [busca, setBusca] = useState('');
  const [filtroStatus, setFiltroStatus] = useState('');
  const [cnpjBusca, setCnpjBusca] = useState('');
  const dadosRef = useRef({});
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [formItens] = Form.useForm();

  useEffect(() => { carregarDados(); }, []);

  const carregarDados = async () => {
    try {
      setLoading(true);
      const rServicos = await api.get('/servicos');
      setServicos(rServicos.data);
      try { const rPropostas = await api.get('/propostas'); setPropostas(rPropostas.data); } catch { setPropostas([]); }
    } catch { message.error('Erro ao carregar serviços'); }
    finally { setLoading(false); }
  };

  const buscarClientePorCnpj = async () => {
    if (!cnpjBusca) { message.warning('Digite um CNPJ para buscar'); return; }
    setBuscandoCnpj(true);
    try {
      const cnpjLimpo = cnpjBusca.replace(/\D/g, '');
      const r = await api.get(`/clientes/buscar-cnpj/${cnpjLimpo}`);
      const clienteData = await api.get(`/clientes/${r.data.cliente_id}`);
      const cnpjsData = await api.get(`/clientes/${r.data.cliente_id}/cnpjs`);
      setClienteSelecionado(clienteData.data);
      setCnpjSelecionado(r.data);
      setCnpjs(cnpjsData.data);
      const cli = clienteData.data;
      const endsFiscais = cli.logradouro_fiscal ? [{ id: 'fiscal_principal', nome_local: 'Endereço Fiscal', logradouro: cli.logradouro_fiscal, numero: cli.numero_fiscal, cidade: cli.cidade_fiscal, estado: cli.estado_fiscal, cep: cli.cep_fiscal, _fiscal: true }] : [];
      setEnderecos([...endsFiscais, ...(cli.enderecos || [])]);
      setContatos(clienteData.data.contatos || []);
      form.setFieldsValue({ cliente_id: r.data.cliente_id, cnpj_faturamento_id: r.data.id, forma_pagamento: clienteData.data.forma_pagamento });
      const endPrincipal = (clienteData.data.enderecos || []).find(e => e.principal);
      const contPrincipal = (clienteData.data.contatos || []).find(c => c.principal);
      if (endPrincipal) form.setFieldsValue({ endereco_id: endPrincipal.id });
      if (contPrincipal) form.setFieldsValue({ contato_id: contPrincipal.id });
      message.success(`Cliente encontrado: ${r.data.razao_social || clienteData.data.razao_social}`);
    } catch (e) {
      if (e.response?.status === 404) message.error('CNPJ não encontrado. Cadastre o CNPJ na aba CNPJs/Filiais do cliente.');
      else message.error('Erro ao buscar cliente');
    } finally { setBuscandoCnpj(false); }
  };

  const adicionarItem = (values) => {
    const servico = servicos.find(s => s.id === values.servico_id);
    if (!servico) return;
    const jaExiste = itensProposta.find(i => i.servico_id === values.servico_id);
    if (jaExiste) {
      setItensProposta(itensProposta.map(i => i.servico_id === values.servico_id ? { ...i, quantidade: i.quantidade + (values.quantidade || 1) } : i));
    } else {
      setItensProposta([...itensProposta, { servico_id: servico.id, nome: servico.nome, equipamento: servico.equipamento, tipo: servico.tipo, valor_base: parseFloat(servico.valor_base), quantidade: values.quantidade || 1 }]);
    }
    formItens.resetFields();
  };

  const irParaServicos = () => {
    if (!clienteSelecionado) { message.warning('Busque e selecione um cliente primeiro'); return; }
    dadosRef.current = form.getFieldsValue(true);
    setStep(1);
  };

  const montarPayload = () => {
    const d = dadosRef.current;
    return {
      cliente_id: d.cliente_id,
      cnpj_faturamento_id: d.cnpj_faturamento_id,
      titulo: d.titulo,
      contato_id: d.contato_id || null,
      endereco_id: (typeof d.endereco_id === 'string' && d.endereco_id.startsWith('fiscal_')) ? null : (d.endereco_id || null),
      tipo_deslocamento: d.tipo_deslocamento || 'perto',
      dias_execucao: d.dias_execucao || 1,
      horas_deslocamento: d.horas_deslocamento || 0,
      distancia_km: d.distancia_km || 0,
      pedagio_valor: d.pedagio_valor || 0,
      horas_estacionamento: d.horas_estacionamento || 0,
      km_viagem: d.km_viagem || 0,
      dias_totais_viagem: d.dias_totais_viagem || 0,
      diarias_aluguel_carro: d.diarias_aluguel_carro || 0,
      km_deslocamento_local: d.km_deslocamento_local || 0,
      crea_fora_mg: creaForaMG,
      desconto: d.desconto || 0,
      desconto_observacao: d.desconto_observacao || null,
      forma_pagamento: d.forma_pagamento || null,
      validade_dias: d.validade_dias || 15,
      observacoes: d.observacoes || null,
      itens: itensProposta,
    };
  };

  const calcular = async () => {
    if (itensProposta.length === 0) { message.warning('Adicione pelo menos um serviço'); return; }
    try {
      const payload = montarPayload();
      const r = await api.post('/propostas/calcular', payload);
      setCalculo(r.data);
      setStep(2);
    } catch (e) { console.error(e); message.error('Erro ao calcular proposta'); }
  };

  const salvarProposta = async () => {
    try {
      const payload = montarPayload();
      await api.post('/propostas', payload);
      message.success('Proposta criada com sucesso!');
      setModalVisible(false); setStep(0); setItensProposta([]); setCalculo(null);
      setCnpjBusca(''); setClienteSelecionado(null); setCnpjSelecionado(null);
      dadosRef.current = {}; form.resetFields(); carregarDados();
    } catch { message.error('Erro ao salvar proposta'); }
  };

  const fmt = (v) => `R$ ${parseFloat(v || 0).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;

  const propostasFiltradas = propostas.filter(p => {
    const b = busca.toLowerCase();
    const matchBusca = !b || (p.numero||'').toLowerCase().includes(b) ||
      (p.razao_social||p.nome_cliente||'').toLowerCase().includes(b) ||
      (p.cnpj||'').replace(/\D/g,'').includes(b.replace(/\D/g,''));
    const matchStatus = !filtroStatus || p.status === filtroStatus;
    return matchBusca && matchStatus;
  });

  const abrirFinanceiro = (r) => {
    setPropostaSel(r);
    formFin.setFieldsValue({
      status_pagamento: r.status_pagamento || 'pendente',
      status_nf: r.status_nf || 'nao_emitida',
      vencimento_boleto: r.vencimento_boleto ? dayjs(r.vencimento_boleto.substring(0,10)) : null,
      inadimplente: r.inadimplente || false,
    });
    setModalFinanceiro(true);
  };

  const salvarFinanceiro = async (values) => {
    try {
      await api.put('/propostas/' + propostaSel.id + '/financeiro', {
        ...values,
        vencimento_boleto: values.vencimento_boleto?.format('YYYY-MM-DD') || null,
      });
      message.success('Status financeiro atualizado!');
      setModalFinanceiro(false);
      carregarDados();
    } catch { message.error('Erro ao atualizar'); }
  };

  const gerarPDFProposta = async (r) => {
    try {
      message.loading({ content: 'Gerando PDF...', key: 'pdf', duration: 0 });
      const res = await api.get('/propostas/' + r.id + '/pdf', { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Proposta-' + r.numero + '.pdf');
      document.body.appendChild(link);
      link.click();
      link.remove();
      message.success({ content: 'PDF gerado!', key: 'pdf' });
    } catch { message.error({ content: 'Erro ao gerar PDF', key: 'pdf' }); }
  };

  const deletarProposta = async (id) => {
    try {
      await api.delete('/propostas/' + id);
      setPropostas(propostas.filter(p => p.id !== id));
      message.success('Proposta removida!');
    } catch { message.error('Erro ao remover proposta'); }
  };

  const gerarOS = async (r) => {
    try {
      const res = await api.post('/os', {
        proposta_id: r.id,
        cliente_id: r.cliente_id,
        observacoes: 'OS gerada da proposta ' + r.numero,
      });
      message.success('OS ' + res.data.numero + ' criada!');
      window.location.href = '/agendamentos?os=' + res.data.id;
    } catch { message.error('Erro ao gerar OS'); }
  };

  const colunas = [
    { title: 'Ações', width: 220, render: (_, r) => (
      <Space size={2}>
        <Tooltip title="Editar"><Button icon={<EditOutlined />} size="small" type="primary" onClick={() => navigate('/propostas/' + r.id + '/editar')} /></Tooltip>
        <Tooltip title="Ver detalhes"><Button icon={<EyeOutlined />} size="small" onClick={() => navigate('/propostas/' + r.id)} /></Tooltip>
        <Tooltip title="Gerar PDF"><Button icon={<FilePdfOutlined />} size="small" style={{color:'#cf1322',borderColor:'#cf1322'}} onClick={() => gerarPDFProposta(r)} /></Tooltip>
        <Tooltip title="Gerar OS"><Button icon={<CalendarOutlined />} size="small" style={{color:'#722ed1',borderColor:'#722ed1'}} onClick={() => gerarOS(r)} /></Tooltip>
        <Tooltip title="Histórico"><Button icon={<MessageOutlined />} size="small" style={{color:'#08979c',borderColor:'#08979c'}} onClick={() => navigate('/propostas/' + r.id)} /></Tooltip>
        <Tooltip title="Status Financeiro"><Button icon={<DollarOutlined />} size="small" style={{color:'#389e0d',borderColor:'#389e0d'}} onClick={() => abrirFinanceiro(r)} /></Tooltip>
        <Popconfirm title="Remover proposta?" onConfirm={() => deletarProposta(r.id)}><Tooltip title="Excluir"><Button icon={<DeleteOutlined />} size="small" danger /></Tooltip></Popconfirm>
      </Space>
    )},
    { title: 'Número', dataIndex: 'numero', width: 110, render: (v) => <Text strong style={{ color: '#1a3c5e' }}>{v}</Text> },
    { title: 'Cliente', dataIndex: 'razao_social', render: (v, r) => v || r.nome_cliente },
    { title: 'CNPJ', dataIndex: 'cnpj', width: 160, render: (v) => v || '-' },
    { title: 'Status', dataIndex: 'status', width: 110, render: (v) => <Tag color={STATUS_CORES[v]}>{STATUS_LABELS[v]}</Tag> },
    { title: 'Total', dataIndex: 'valor_total', width: 110, render: (v) => fmt(v) },
    { title: 'Pagamento', dataIndex: 'status_pagamento', width: 110, render: (v) => <Tag color={STATUS_PGTO_CORES[v||'pendente']}>{STATUS_PGTO_LABELS[v||'pendente']}</Tag> },
    { title: 'NF', dataIndex: 'status_nf_real', width: 120, render: (v, r) => {
      const s = v || r.status_nf || 'nao_emitida';
      const num = s === 'emitida' && r.numero_nf ? ' ' + r.numero_nf : '';
      return <Tag color={STATUS_NF_CORES[s] || 'default'}>{(STATUS_NF_LABELS[s] || s) + num}</Tag>;
    }},
    { title: 'Data', dataIndex: 'criado_em', width: 100, render: (v) => new Date(v).toLocaleDateString('pt-BR') },
  ];

  const servicosAgrupados = servicos.reduce((acc, s) => {
    const grupo = s.tipo === 'inspecao' ? '🔍 Inspeções' : s.tipo === 'calibracao' ? '⚙️ Calibrações' : '📋 Outros Serviços';
    if (!acc[grupo]) acc[grupo] = [];
    acc[grupo].push(s);
    return acc;
  }, {});

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <Title level={4} style={{ margin: 0 }}>Propostas</Title>

      </div>
      <Tabs defaultActiveKey="servicos" items={[
        {
          key: 'servicos',
          label: <span><FileTextOutlined /> {"Propostas de Servi\u00e7o"}</span>,
          children: (
            <Card>
              <Space style={{ marginBottom: 12 }} wrap>
                <Input.Search placeholder={"Buscar por n\u00famero, cliente ou CNPJ..."} allowClear onChange={e => setBusca(e.target.value)} onSearch={v => setBusca(v)} style={{ width: 300 }} />
                <Select allowClear placeholder="Filtrar por status" onChange={v => setFiltroStatus(v||'')} style={{ width: 180 }}>
                  {Object.entries(STATUS_LABELS).map(([k, v]) => <Option key={k} value={k}>{v}</Option>)}
                </Select>
              </Space>
              <Table columns={colunas} dataSource={propostasFiltradas} loading={loading} rowKey="id" locale={{ emptyText: 'Nenhuma proposta ainda.' }} scroll={{ x: 900 }} />
            </Card>
          ),
        },
        {
          key: 'produtos',
          label: <span><ShoppingCartOutlined /> Propostas de Produto</span>,
          children: <PropostasProdutosLista />,
        },
      ]} />

      <Modal title="Nova Proposta" open={modalVisible} onCancel={() => setModalVisible(false)} footer={null} width={950} style={{ top: 20 }}>
        <Steps current={step} style={{ marginBottom: 24 }} items={[{ title: 'Cliente e Deslocamento' }, { title: 'Serviços' }, { title: 'Revisão' }]} />

        <div style={{ display: step === 0 ? 'block' : 'none' }}>
          <Form form={form} layout="vertical" preserve={true}>
            <Divider orientation="left">Identificação do Cliente</Divider>
            <Row gutter={16} align="bottom">
              <Col span={14}>
                <Form.Item label="Buscar cliente por CNPJ">
                  <Input.Search value={cnpjBusca} onChange={(e) => setCnpjBusca(e.target.value)} onSearch={buscarClientePorCnpj} placeholder="Digite o CNPJ com ou sem formatação" enterButton={<><SearchOutlined /> Buscar</>} loading={buscandoCnpj} />
                </Form.Item>
              </Col>
              {clienteSelecionado && (
                <Col span={10}>
                  <div style={{ padding: '8px 12px', background: '#f6ffed', borderRadius: 8, border: '1px solid #b7eb8f', marginBottom: 24 }}>
                    <Text strong style={{ color: '#52c41a' }}>✓ {clienteSelecionado.razao_social || clienteSelecionado.nome}</Text>
                    <br /><Text type="secondary">{cnpjSelecionado?.cnpj}</Text>
                  </div>
                </Col>
              )}
            </Row>
            {clienteSelecionado && (<>
              <Form.Item name="cliente_id" hidden><Input /></Form.Item>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item name="cnpj_faturamento_id" label="CNPJ para Faturamento">
                    <Select onChange={(id) => setCnpjSelecionado(cnpjs.find(c => c.id === id))}>
                      {cnpjs.map(c => <Option key={c.id} value={c.id}>{c.cnpj} — {c.razao_social} {c.matriz ? '(Matriz)' : ''}</Option>)}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item name="titulo" label="Título da Proposta" rules={[{ required: true }]}>
                    <Input placeholder="Ex: Inspeção NR-13 2026" />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item name="contato_id" label="Contato Responsável">
                    <Select placeholder="Selecione o contato" allowClear>
                      {contatos.map(c => <Option key={c.id} value={c.id}>{c.nome} — {c.setor}{c.principal ? ' ★' : ''}</Option>)}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item name="endereco_id" label="Endereço de Atendimento">
                    <Select placeholder="Selecione o endereço" allowClear>
                      {enderecos.map(e => <Option key={e.id} value={e.id}>{e.nome_local}{e.logradouro ? ' — ' + e.logradouro + (e.numero ? ', ' + e.numero : '') : ''} — {e.cidade}/{e.estado}{e.principal ? ' ★' : ''}</Option>)}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </>)}
            <Divider orientation="left">Deslocamento</Divider>
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item name="tipo_deslocamento" label="Tipo de Deslocamento" initialValue="perto">
                  <Select onChange={(v) => setTipoDeslocamento(v)}>
                    <Option value="perto">Perto (sem pernoite)</Option>
                    <Option value="viagem">Viagem (com pernoite)</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="dias_execucao" label="Dias de execução" rules={[{ required: true }]}>
                  <InputNumber style={{ width: '100%' }} min={1} />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="horas_deslocamento" label="Horas de deslocamento (ida+volta)">
                  <InputNumber style={{ width: '100%' }} min={0} step={0.5} />
                </Form.Item>
              </Col>
            </Row>
            {tipoDeslocamento === 'perto' ? (
              <Row gutter={16}>
                <Col span={8}><Form.Item name="distancia_km" label="Distância km (ida+volta)"><InputNumber style={{ width: '100%' }} min={0} /></Form.Item></Col>
                <Col span={8}><Form.Item name="pedagio_valor" label="Pedágio R$ (ida+volta total)"><InputNumber style={{ width: '100%' }} min={0} precision={2} /></Form.Item></Col>
                <Col span={8}><Form.Item name="horas_estacionamento" label="Horas de estacionamento"><InputNumber style={{ width: '100%' }} min={0} step={0.5} /></Form.Item></Col>
              </Row>
            ) : (
              <>
                <Row gutter={16}>
                  <Col span={6}><Form.Item name="km_viagem" label="Km total viagem (ida+volta)"><InputNumber style={{ width: '100%' }} min={0} /></Form.Item></Col>
                  <Col span={6}><Form.Item name="dias_totais_viagem" label="Dias totais"><InputNumber style={{ width: '100%' }} min={1} /></Form.Item></Col>
                  <Col span={6}><Form.Item name="pedagio_valor" label="Pedágio R$ (total ida+volta)"><InputNumber style={{ width: '100%' }} min={0} precision={2} /></Form.Item></Col>
                  <Col span={6}><Form.Item name="diarias_aluguel_carro" label="Diárias aluguel de carro"><InputNumber style={{ width: '100%' }} min={0} /></Form.Item></Col>
                </Row>
                <Row gutter={16}>
                  <Col span={12}><Form.Item name="km_deslocamento_local" label="Km deslocamento local hotel→cliente (ida+volta/dia)"><InputNumber style={{ width: '100%' }} min={0} /></Form.Item></Col>
                </Row>
              </>
            )}
            <Row gutter={16} style={{ marginTop: 8 }}>
              <Col span={8}>
                <div style={{ padding: '12px', background: '#fff7e6', borderRadius: 8, border: '1px solid #ffd591' }}>
                  <Checkbox checked={creaForaMG} onChange={(e) => setCreaForaMG(e.target.checked)}>
                    <Text strong>CREA fora de MG</Text>
                    <br /><Text type="secondary" style={{ fontSize: 12 }}>Adiciona custo da licença do CREA do estado</Text>
                  </Checkbox>
                </div>
              </Col>
              <Col span={8}>
                <Form.Item name="forma_pagamento" label="Forma de Pagamento">
                  <Select>{FORMAS_PAGAMENTO.map(f => <Option key={f} value={f}>{f}</Option>)}</Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="validade_dias" label="Validade (dias)" initialValue={15}>
                  <InputNumber style={{ width: '100%' }} min={1} />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item name="desconto" label="Desconto (R$)">
                  <InputNumber style={{ width: '100%' }} min={0} precision={2} prefix="R$" />
                </Form.Item>
              </Col>
              <Col span={16}>
                <Form.Item name="desconto_observacao" label="Motivo do desconto">
                  <Input placeholder="Ex: Cliente fidelidade..." />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item name="observacoes" label="Observações internas">
              <Input.TextArea rows={2} />
            </Form.Item>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button type="primary" onClick={irParaServicos}>Próximo: Serviços →</Button>
            </div>
          </Form>
        </div>

        {step === 1 && (
          <div>
            <Alert message={`Cliente: ${clienteSelecionado?.razao_social || clienteSelecionado?.nome} | Tipo: ${dadosRef.current.tipo_deslocamento === 'viagem' ? 'Viagem' : 'Perto'} | Dias: ${dadosRef.current.dias_execucao || 1} | Km: ${dadosRef.current.distancia_km || dadosRef.current.km_viagem || 0}`} type="info" style={{ marginBottom: 16 }} />
            <Form form={formItens} layout="vertical" onFinish={adicionarItem}>
              <Row gutter={16} align="bottom">
                <Col span={14}>
                  <Form.Item name="servico_id" label="Serviço" rules={[{ required: true }]}>
                    <Select showSearch optionFilterProp="children" placeholder="Selecione o serviço">
                      {Object.entries(servicosAgrupados).map(([grupo, items]) => (
                        <Select.OptGroup key={grupo} label={grupo}>
                          {items.map(s => <Option key={s.id} value={s.id}>{s.nome}{s.equipamento ? ` — ${s.equipamento}` : ''} | {fmt(s.valor_base)}</Option>)}
                        </Select.OptGroup>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item name="quantidade" label="Qtd." initialValue={1}>
                    <InputNumber style={{ width: '100%' }} min={1} />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label=" ">
                    <Button type="primary" htmlType="submit" icon={<PlusOutlined />} block>Adicionar</Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
            <Divider>Serviços adicionados ({itensProposta.length})</Divider>
            {itensProposta.length === 0 && <Alert message="Nenhum serviço adicionado ainda." type="info" />}
            {itensProposta.map((item, idx) => (
              <Card key={idx} size="small" style={{ marginBottom: 8 }} extra={<Button size="small" danger onClick={() => setItensProposta(itensProposta.filter((_, i) => i !== idx))}>Remover</Button>}>
                <Row>
                  <Col span={12}><Text strong>{item.nome}</Text>{item.equipamento && <Text type="secondary"> — {item.equipamento}</Text>}</Col>
                  <Col span={4}><Tag color={item.tipo === 'inspecao' ? 'blue' : item.tipo === 'calibracao' ? 'green' : 'default'}>{item.tipo === 'inspecao' ? 'Inspeção' : item.tipo === 'calibracao' ? 'Calibração' : 'Outros'}</Tag></Col>
                  <Col span={4}><Text>Qtd: {item.quantidade}</Text></Col>
                  <Col span={4} style={{ textAlign: 'right' }}><Text>{fmt(item.valor_base)} /un</Text></Col>
                </Row>
              </Card>
            ))}
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 16 }}>
              <Button onClick={() => setStep(0)}>← Voltar</Button>
              <Button type="primary" icon={<CalculatorOutlined />} onClick={calcular} disabled={itensProposta.length === 0}>Calcular Proposta →</Button>
            </div>
          </div>
        )}

        {step === 2 && calculo && (
          <div>
            <Alert message={`Proposta para: ${clienteSelecionado?.razao_social || clienteSelecionado?.nome} — ${cnpjSelecionado?.cnpj || ''}`} type="info" showIcon style={{ marginBottom: 16 }} />
            <Card title="Itens da Proposta" size="small" style={{ marginBottom: 16 }}>
              <Table size="small" pagination={false} dataSource={calculo.itens_calculados} rowKey="servico_id"
                columns={[
                  { title: 'Serviço', render: (_, r) => `${r.nome}${r.equipamento ? ' — ' + r.equipamento : ''}` },
                  { title: 'Tipo', dataIndex: 'tipo', render: (v) => <Tag color={v === 'inspecao' ? 'blue' : v === 'calibracao' ? 'green' : 'default'}>{v === 'inspecao' ? 'Inspeção' : v === 'calibracao' ? 'Calibração' : 'Outros'}</Tag> },
                  { title: 'Qtd', dataIndex: 'quantidade', width: 50 },
                  { title: 'Base', dataIndex: 'valor_base', render: (v) => fmt(v) },
                  { title: 'Mobilização', dataIndex: 'custo_mobilizacao', render: (v) => fmt(v) },
                  { title: 'ART', dataIndex: 'custo_art', render: (v) => fmt(v) },
                  { title: 'Vl. Unit.', dataIndex: 'valor_unitario', render: (v) => <Text strong>{fmt(v)}</Text> },
                  { title: 'Total', dataIndex: 'valor_total', render: (v) => <Text strong style={{ color: '#1a3c5e' }}>{fmt(v)}</Text> },
                ]}
              />
            </Card>
            <Card size="small">
              <Row>
                <Col span={12}>
                  <Text>Custo mobilização total: <Text strong>{fmt(calculo.custo_mobilizacao)}</Text></Text>
                  {creaForaMG && <><br /><Tag color="orange">CREA fora de MG incluído</Tag></>}
                </Col>
                <Col span={12} style={{ textAlign: 'right' }}>
                  <div><Text>Subtotal: <Text strong>{fmt(calculo.subtotal)}</Text></Text></div>
                  {calculo.desconto > 0 && <div><Text style={{ color: 'red' }}>Desconto: - <Text strong>{fmt(calculo.desconto)}</Text></Text></div>}
                  <div><Text>Imposto: <Text strong>{fmt(calculo.valor_imposto)}</Text></Text></div>
                  <Divider style={{ margin: '8px 0' }} />
                  <Title level={3} style={{ color: '#1a3c5e', margin: 0 }}>TOTAL: {fmt(calculo.valor_total)}</Title>
                </Col>
              </Row>
            </Card>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 16 }}>
              <Button onClick={() => setStep(1)}>← Voltar</Button>
              <Button type="primary" icon={<FileTextOutlined />} onClick={salvarProposta} size="large">Salvar Proposta</Button>
            </div>
          </div>
        )}
      </Modal>

    <Modal title="Status Financeiro" open={modalFinanceiro} onCancel={() => setModalFinanceiro(false)} footer={null} width={450}>
      <Form form={formFin} layout="vertical" onFinish={salvarFinanceiro}>
        <Form.Item name="vencimento_boleto" label="Vencimento do Boleto">
          <DatePicker format="DD/MM/YYYY" style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item name="status_pagamento" label="Status do Pagamento">
          <Select>
            <Option value="pendente">Pendente</Option>
            <Option value="pago">Pago</Option>
            <Option value="inadimplente">Inadimplente</Option>
            <Option value="parcelado">Parcelado</Option>
          </Select>
        </Form.Item>
        <Form.Item name="status_nf" label="Status da Nota Fiscal">
          <Select>
            <Option value="nao_emitida">Sem NF</Option>
            <Option value="emitida">NF Emitida</Option>
            <Option value="cancelada">NF Cancelada</Option>
          </Select>
        </Form.Item>
        <Form.Item name="inadimplente" label="Inadimplente?" valuePropName="checked">
          <Switch checkedChildren="Sim" unCheckedChildren="Não" />
        </Form.Item>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <Button onClick={() => setModalFinanceiro(false)}>Cancelar</Button>
          <Button type="primary" htmlType="submit">Salvar</Button>
        </div>
      </Form>
    </Modal>
    </>
  );
}

export default Propostas;
